export default "/images/vendor/flag-icons/flags/1x1/dz.svg?676246527fe04242f0f722440e577866";